const historytablecolumns = [
    {
        title: "Sr No"
    },
    {
        title: "CourierId"
    },
    {
        title: "Source"
    },
    {
        title: "Destination"
    },
    {
        title: "Departure"
    },
    {
        title: "Arrival"
    },
    {
        title: "Estimated_Time"
    },
    {
        title: "Actual_Time"
    },
    {
        title: "Cost"
    },
    {
        title: "Track"
    }
];

export default historytablecolumns;